import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "trigger"]

  show() {
    this.triggerTarget.hidden = true
    this.formTarget.hidden = false
    this.inputTarget.focus()
  }

  hide() {
    if (this.inputTarget.value.trim() !== "") return

    this.formTarget.hidden = true
    this.inputTarget.value = ""
    this.triggerTarget.hidden = false
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      if (this.inputTarget.value.trim() === "") return
      this.formTarget.requestSubmit()
    }
    if (event.key === "Escape") {
      this.inputTarget.value = ""
      this.formTarget.hidden = true
      this.triggerTarget.hidden = false
    }
  }

  reset() {
    this.inputTarget.value = ""
    this.formTarget.hidden = true
    this.triggerTarget.hidden = false
  }
}
